import React, { useState, useRef, useEffect } from 'react';
import { getUrlParameter } from '../../constants/commonFunction';

const styles = {
  modal: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    width: "100%",
    padding: "20px",
    boxSizing: "border-box"
  },
  heading: {
    margin: "0 0 15px",
    fontSize: "12px",
    fontWeight: "bold",
    fontStyle: "inter",
  },
  listContainer: {
    maxHeight: "200px",
    overflowY: "auto",
    marginBottom: "20px"
  },
  item: {
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "8px",
    backgroundColor: "#f5f5f5",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "12px",
  },
  itemSelected: {
    backgroundColor: "#e6f0fb",
    fontWeight: "bold"
  },
  tick: {
    fontSize: "12px",
    color: "#007BFF"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  cancelBtn: {
    flex: 1,
    marginRight: "10px",
    padding: "12px",
    borderRadius: "30px",
    border: "1px solid #00000080",
    color: "red",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: "12px",
  },
  addBtn: {
    flex: 1,
    padding: "12px",
    borderRadius: "30px",
    backgroundColor: "#E42125",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontSize: "12px",
  },
  addBtnDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed"
  }
};


export const InvestigatorNameList = ({ onCancelHandler = () => { }, vendorDetails = {}, onAddHandler = () => { } }) => {
  const [selected, setSelected] = useState([]);
  const case_id = (getUrlParameter('case'));

  const toggleSelection = (empID) => {
    setSelected((prev) =>
      prev.includes(empID)
        ? prev.filter((n) => n !== empID)
        : [...prev, empID]
    );
  };

  const handleAdd = () => {
    if (selected.length > 0) {
      onAddHandler(case_id, selected);
    }
  };
  
  return (
    <div>
      <div style={styles.modal}>
        <h3 style={styles.heading}>Add Investigator</h3>
        <div style={styles.listContainer}>
          {vendorDetails ?.vendor_employees ?.length ?
            vendorDetails ?.vendor_employees ?.map((name) => (
              <div
                key={name.investigator_name}
                style={{
                  ...styles.item,
                  ...(selected.includes(name.vendor_employee_id) ? styles.itemSelected : {})
                }}
                onClick={() => toggleSelection(name.vendor_employee_id)}
              >
                <span>{name.investigator_name}</span>
                {selected.includes(name.vendor_employee_id) && <span style={styles.tick}>✔️</span>}
              </div>
            )) :
              <div>No more Investigator.</div>
          }
        </div>
        <div style={styles.buttonContainer}>
          <button style={styles.cancelBtn} onClick={onCancelHandler}>
            CANCEL
        </button>
          <button
            style={{
              ...styles.addBtn,
              ...(selected.length === 0 ? styles.addBtnDisabled : {})
            }}
            onClick={handleAdd}
            disabled={selected.length === 0}
          >
            + ADD
        </button>
        </div>
      </div>
    </div>
  )
}
